import { render, staticRenderFns } from "./trainingItem.vue?vue&type=template&id=95de1842&scoped=true"
import script from "./trainingItem.vue?vue&type=script&lang=js"
export * from "./trainingItem.vue?vue&type=script&lang=js"
import style0 from "./trainingItem.vue?vue&type=style&index=0&id=95de1842&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95de1842",
  null
  
)

export default component.exports